import React, {useState, useEffect} from "react";
import { userModel } from "../index.js";
import {TestFormView} from "../views/testFormView.js";
import useModelProp from "../useModelProp.js";

function TestForm(props) {
  const currentTask = useModelProp(userModel, "currentTask");
  const [submit, setSubmit] = useState(true);
  return React.createElement(TestFormView, {
    //timer,
    //question: userModel.questions[userModel.currentTask][userModel.currentTaskIndex].instruction,
    id: userModel.id,
    onSubmit: () => setSubmit(false),
    submitValue: submit,
    onNext: () =>  {
        props.history.push("/test");
        userModel.secondTest = true;
 }
    });
}

export default TestForm;